module.exports = __webpack_public_path__ + "static/img/homepage-header-FalleN.c25e56b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/homepage-header-FalleN.jpg
// module id = 6jCR
// module chunks = 38